import { render, staticRenderFns } from "./SkriningMppInput.vue?vue&type=template&id=5f851bbc&scoped=true&"
import script from "./SkriningMppInput.vue?vue&type=script&lang=ts&"
export * from "./SkriningMppInput.vue?vue&type=script&lang=ts&"
import style0 from "./SkriningMppInput.vue?vue&type=style&index=0&id=5f851bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f851bbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VContainer,VExpandTransition,VIcon,VRow,VSheet,VSpacer})
